const DEFAULT_SEAT_MAP_SVG_SIZE = 25;

export const svgSeatChoice = (size = DEFAULT_SEAT_MAP_SVG_SIZE) =>
  '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="' +
  size +
  '" height="' +
  size +
  '"><path d="m14.646,19l1,2h-6.795c-3.279,0-6.158-2.327-6.845-5.533L.191,7h2.046l1.725,8.047c.491,2.291,2.546,3.953,4.889,3.953h5.795Zm5.972,3l-3.5-7h-8.171c-.475,0-.887-.338-.98-.804l-.439-2.196h7.473v-2h-7.873l-.6-3h-2.039l1.518,7.589c.279,1.397,1.517,2.411,2.941,2.411h6.935l3.5,7h3.618v-2h-2.382ZM5.5,5c1.379,0,2.5-1.121,2.5-2.5S6.878,0,5.5,0s-2.5,1.121-2.5,2.5,1.121,2.5,2.5,2.5Z"/></svg>';

export const svgSeatBlocked = (size = DEFAULT_SEAT_MAP_SVG_SIZE) =>
  '<svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="' +
  size +
  '" height="' +
  size +
  '"><path fill="#97B6CC" d="M23.707.293h0a1,1,0,0,0-1.414,0L12,10.586,1.707.293a1,1,0,0,0-1.414,0h0a1,1,0,0,0,0,1.414L10.586,12,.293,22.293a1,1,0,0,0,0,1.414h0a1,1,0,0,0,1.414,0L12,13.414,22.293,23.707a1,1,0,0,0,1.414,0h0a1,1,0,0,0,0-1.414L13.414,12,23.707,1.707A1,1,0,0,0,23.707.293Z"/></svg>';

export const svgSeatLegend = (size = DEFAULT_SEAT_MAP_SVG_SIZE) =>
  '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="' +
  size +
  '" height="' +
  size +
  '"><path d="M24,3c0,.55-.45,1-1,1H1c-.55,0-1-.45-1-1s.45-1,1-1H23c.55,0,1,.45,1,1ZM15,20h-6c-.55,0-1,.45-1,1s.45,1,1,1h6c.55,0,1-.45,1-1s-.45-1-1-1Zm4-9H5c-.55,0-1,.45-1,1s.45,1,1,1h14c.55,0,1-.45,1-1s-.45-1-1-1Z"/></svg>';

export const svgSeatBestForInfant = (premium = false, size = DEFAULT_SEAT_MAP_SVG_SIZE) =>
  '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="' +
  size +
  '" height="' +
  size +
  '">\n' +
  '<path fill="' +
  (premium ? '#7B3F61' : '#97B6CC') +
  '" d="M23,21.877v1.295l-1.237,.828h-3.595l2.712-1.816-1.819-4.139c-.707-1.262-2.044-2.045-3.49-2.045h-7.141c-1.446,0-2.783,.783-3.49,2.045l-1.819,4.139,2.712,1.816H2.237l-1.237-.828v-1.295l2.195-4.81c1.061-1.893,3.066-3.067,5.234-3.067h7.141c2.168,0,4.174,1.175,5.234,3.066l2.195,4.811ZM6,6C6,2.691,8.691,0,12,0s6,2.691,6,6-2.691,6-6,6-6-2.691-6-6Zm2,0c0,2.206,1.794,4,4,4s4-1.794,4-4-1.794-4-4-4-4,1.794-4,4Zm7.5,11.5c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5,2.5-1.119,2.5-2.5-1.119-2.5-2.5-2.5Zm-4.5,.5h-2v4.049l2.538,1.951h3.423l-3.962-3.049v-2.951Z"/>\n' +
  '</svg>';

export const svgSelectorCaret = (width = 14, height = 8) =>
  '<svg width="' +
  width +
  '" height="' +
  height +
  '" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
  '<path d="M6.58333 7.9C6.2789 7.9 5.9745 7.74583 5.67007 7.59169L0.342487 2.19656C-0.114162 1.73412 -0.114162 0.963416 0.342487 0.34683C0.799137 -0.11561 1.56015 -0.11561 2.16901 0.34683L6.58333 4.81707L10.9977 0.34683C11.4543 -0.11561 12.2153 -0.11561 12.8242 0.34683C13.2808 0.809269 13.2808 1.57997 12.8242 2.19656L7.4966 7.59169C7.19216 7.89998 6.88777 7.9 6.58333 7.9Z" fill="black"/>\n' +
  '</svg>';

export const svgInfo = (size = DEFAULT_SEAT_MAP_SVG_SIZE) =>
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="' +
  size +
  '" height="' +
  size +
  '"><g id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z"/><path d="M14,19H12V12H10V10h2a2,2,0,0,1,2,2Z"/><circle cx="12" cy="6.5" r="1.5"/></g></svg>';

export const svgChange = (size = DEFAULT_SEAT_MAP_SVG_SIZE) =>
  '<svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="' +
  size +
  '" height="' +
  size +
  '"><path d="M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z"/></svg>';

const seatMapIcons = {
  svgSeatChoice,
  svgSeatBlocked,
  svgSeatLegend,
  svgSeatBestForInfant,
  svgInfo,
  svgChange,
};

export default seatMapIcons;
